import ErrorBoundary from './ErrorBoundary'
import React from 'react'

type AppErrorBoundaryProps = {
    fallbackElement: React.ReactElement
}

class AppErrorBoundary extends ErrorBoundary<AppErrorBoundaryProps> {
    render() {
        const {fallbackElement} = this.props
        const {error} = this.state

        if (error) {
            return fallbackElement
        }

        return super.render()
    }
}

export {AppErrorBoundary}
